export default "__VITE_ASSET__DRJ7hoNK__"